import env from "@libs/util/environment";
const capitalizeString = str => str.charAt(0).toUpperCase() + str.slice(1);
class BillingService {
  constructor() {
    this.settings = null;
  }
  setSettings(settings) {
    this.settings = settings;
  }
  createInvoice(invoice_id) {
    const postfix = capitalizeString(env.getRegion());
    return this[`createInvoice${postfix}`](invoice_id); //call createOrder method specific by region
  }
  createInvoiceRu() {
    throw new Error("not implemented");
  }
  createInvoiceEu() {
    throw new Error("not implemented");
  }
}
export default BillingService;
